import React from 'react'
import PropTypes from 'prop-types'
import TooltipWrapperRaw from '~/components/common/TooltipWrapper'

const TooltipWrapper = ({ field, children, transformValue }) => (
  <TooltipWrapperRaw value={transformValue(field)}>
    {children}
  </TooltipWrapperRaw>
)

TooltipWrapper.defaultProps = {
  transformValue: (data) => data.value,
}

TooltipWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  field: PropTypes.shape().isRequired,
  transformValue: PropTypes.func,
}

export default TooltipWrapper
